/**
 * @generated SignedSource<<fc907df9b725f7b8e28ba03cd7adb459>>
 * @relayHash 1b8d0a8713ed0e6d36ca3f1051127589
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 581152a666d4ec48c9f4eed3434a0d5f670a46565b37ca202a69a0e8fe145a8f

import type { ConcreteRequest, Mutation } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type slackInviterNotificationMutation$variables = {
  cloudId: string;
  isEnabled: boolean;
};
export type slackInviterNotificationMutation$data = {
  readonly jira: {
    readonly updateGlobalNotificationPreferences: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly preferences: {
        readonly " $fragmentSpreads": FragmentRefs<"slackInviterNotif_personalSettingsDigestNotifications_SlackInviterNotification">;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type slackInviterNotificationMutation = {
  response: slackInviterNotificationMutation$data;
  variables: slackInviterNotificationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isEnabled"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "fields": [
      {
        "items": [
          {
            "fields": [
              {
                "kind": "Literal",
                "name": "channel",
                "value": "SLACK"
              },
              {
                "kind": "Variable",
                "name": "isEnabled",
                "variableName": "isEnabled"
              },
              {
                "kind": "Literal",
                "name": "type",
                "value": "PROJECT_INVITER_NOTIFICATION"
              }
            ],
            "kind": "ObjectValue",
            "name": "preferences.0"
          }
        ],
        "kind": "ListValue",
        "name": "preferences"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "concreteType": "MutationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "message"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "slackInviterNotificationMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraUpdateGlobalPreferencesPayload",
            "kind": "LinkedField",
            "name": "updateGlobalNotificationPreferences",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "JiraNotificationPreferences",
                "kind": "LinkedField",
                "name": "preferences",
                "plural": false,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "slackInviterNotif_personalSettingsDigestNotifications_SlackInviterNotification"
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "slackInviterNotificationMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraUpdateGlobalPreferencesPayload",
            "kind": "LinkedField",
            "name": "updateGlobalNotificationPreferences",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "JiraNotificationPreferences",
                "kind": "LinkedField",
                "name": "preferences",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "projectInviterNotification",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "id"
                      },
                      {
                        "concreteType": "JiraNotificationChannel",
                        "kind": "LinkedField",
                        "name": "slackChannel",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "isEnabled"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "581152a666d4ec48c9f4eed3434a0d5f670a46565b37ca202a69a0e8fe145a8f",
    "metadata": {},
    "name": "slackInviterNotificationMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "0107d8fde7db2faf58350b7b99452f18";

export default node;
